var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table',{staticClass:"table table-bordered tableinfo"},[_c('tr',[_c('td',[_c('b',[_vm._v("Nome do Programa de Afiliados:")]),_vm._v("\n        "+_vm._s(_vm.dados.nome)+"\n      ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }